import { Autocomplete, TextField } from "@mui/material";

type SelectAutocompleteMultipleProps<T> = {
  label: string;
  /**You can use the limitTags prop to limit the number of displayed options when not focused. */
  limitTags?: number;
  options: T[];
  /**Used to determine the string value for a given option. It's used to fill the input (and the list box options if renderOption is not provided). */
  getOptionLabel: (option: T) => string;
  /**If your options are objects, you must provide the isOptionEqualToValue prop to ensure correct selection and highlighting */
  isOptionEqualToValue: (option: T, value: T) => boolean;
  value: T[];
  onChange: (event: React.SyntheticEvent, newValue: T[]) => void;
};

/** This component inherits from Autocomplete component MUI library */
const SelectAutocompleteMultiple = <T,>({
  label,
  limitTags = 2,
  options,
  getOptionLabel,
  isOptionEqualToValue,
  value,
  onChange,
}: SelectAutocompleteMultipleProps<T>) => {
  return (
    <Autocomplete
      multiple
      limitTags={limitTags}
      options={options}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      value={value}
      onChange={onChange}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
};

export default SelectAutocompleteMultiple;
